<template>
  <div class="homeview-style theme-background">
    <div class="homeview-header" v-if="$route.meta.showHeader">
      <div v-if="userdisable">
        <Newmymenu />
      </div>
      <div v-else>
        <Homeheader></Homeheader>
      </div>
    </div>
    <!-- 内容 -->
    <Content class="content-style" />
    <!-- <div v-if="ishome">
      <homeFooter></homeFooter>
    </div>
    <div v-else>
      <Footer v-if="$route.meta.showfooter"></Footer>
    </div> -->
    <div
      v-if="ishome && registerServiceImg"
      class="wechat-service-dock"
      :class="{
        'position-left': iconPosition === 'left',
        'has-newbie-task-reminder': showNewbieTaskReminder,
      }"
      @mouseenter="showWechatQr = true"
      @mouseleave="showWechatQr = false"
    >
      <transition name="el-zoom-in-bottom">
        <div v-show="showWechatQr" class="qr-popover-card">
          <div class="qr-image-wrapper">
            <img :src="registerServiceImg" alt="wechat-service-qr" />
          </div>
          <p class="qr-text">添加企业微信申请更多服务</p>
        </div>
      </transition>
      <button
        class="dock-btn wechat-btn"
        type="button"
        @click.stop="showWechatQr = !showWechatQr"
      >
        <span class="wechat-btn-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm15 0h3v3h-3v-3zm-5 0h3v3h-3v-3zm0 5h3v3h-3v-3zm5 0h3v3h-3v-3z"
            />
          </svg>
        </span>
      </button>
    </div>
    <NewbieTaskReminder
      @visibility-change="showNewbieTaskReminder = $event"
    />
    <!-- Ai对话 -->
    <div
      class="ai-chat-trigger"
      :class="{ 'has-newbie-task-reminder': showNewbieTaskReminder }"
      @click="handleTriggerClick"
    >
      <div class="robot_style">
        <LottiePlayer
          class="robot-anmation"
          src="/lottie/robotanimation/data.json"
          width="50px"
          height="50px"
          :loop="true"
          :autoplay="true"
        ></LottiePlayer>
        <aicanvasIcons name="robotIcon1" />
      </div>
      <!-- <div v-if="showRobotBubble" class="ai-chat-bubble" @click.stop>
        <span class="bubble-text">{{
          $t("home.homeview.aiAssistant.greeting")
        }}</span>
        <span class="bubble-close" @click.stop="closeRobotBubble">
          <aicanvasIcons name="ai-close-icon" />
        </span>
      </div> -->
    </div>
    <div
      v-if="showChatDialog"
      class="chat-dialog-container"
      :class="{ 'position-left': iconPosition === 'left' }"
      ref="chatDialog"
    >
      <div class="chat-controls">
        <span class="position-toggle" @click="togglePosition">
          <aicanvasIcons
            :name="iconPosition === 'left' ? 'rightIcon' : 'leftIcon'"
          />
        </span>
        <div class="diverline"></div>
        <span class="close-button" @click="toggleChatDialog">
          <aicanvasIcons name="closeIcon" />
        </span>
      </div>
      <AIChat
        ref="aiRobot"
        :on-graph-data="updateGraphData"
        :ai_Model_Types="ai_Model_Types"
      />
      <!-- 水平调整手柄（左右拉伸） -->
      <div
        class="resize-handle horizontal-handle"
        :class="{ 'position-left': iconPosition === 'left' }"
        @mousedown="startResizingWidth"
      ></div>
      <!-- 垂直调整手柄（上下拉伸） -->
      <div
        class="resize-handle vertical-handle"
        @mousedown="startResizingHeight"
      ></div>
      <!-- 对角线调整手柄（同时调整宽度和高度） -->
      <div
        class="resize-handle diagonal-handle"
        :class="{ 'position-left': iconPosition === 'left' }"
        @mousedown="startResizingBoth"
      ></div>
    </div>
    <div
      class="temporary_tooltiptext"
      v-if="ishome && !isbindPhone && showPhoneTip"
    >
      <div class="temporary_tooltiptext_left"></div>
      <div class="temporary_tooltiptext_container">
        <tooltipicon name="unsavedCanvasWarning" />
        <span class="tip-text">
          {{ $t("personalinfo.phoneBinding.notBoundTip") }}
        </span>
        <span class="tip-link" @click="goToBindPhone">
          {{ $t("personalinfo.phoneBinding.goToBind") }}
        </span>
        <span class="closeIcon" @click="showPhoneTip = false">
          <tooltipicon name="closeGraySmall" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Footer from "@/components/newtheme/otherfooter.vue";
import homeFooter from "@/components/newtheme/homefooter.vue";
import { stretchAdjustment } from "@/utils/AICanvasMixins/stretchAdjustment.js";
import Homeheader from "@/views/newtheme/newhome/homeheader.vue";
import Newmymenu from "@/views/newtheme/newhome/initilarolemenu.vue";
import Content from "./Content.vue";
import AIChat from "@/views/AIcanvas/AIChat.vue";
import aicanvasIcons from "@/components/icons/aiIcons.vue";
import LottiePlayer from "@/views/newtheme/newhome/LottiePlayer.vue";
import { getUser } from "@/aips/userManage";
import tooltipicon from "@/components/icons/tooltipicon.vue";
import NewbieTaskReminder from "./NewbieTaskReminder.vue";
export default {
  mixins: [stretchAdjustment],
  components: {
    Homeheader,
    Content,
    Newmymenu,
    Footer,
    homeFooter,
    AIChat,
    aicanvasIcons,
    LottiePlayer,
    tooltipicon,
    NewbieTaskReminder,
    // Quitsavedialog
  },
  provide() {
    return {
      reload: this.reload, //把方法传递给下级组件
    };
  },
  data() {
    return {
      userdisable: false,
      ishome: false,
      ai_Model_Types: "KNOWLEDGE",
      // isquitsavedialog:false,
      showRobotBubble: true,
      showWechatQr: false,
      isbindPhone: true,
      showPhoneTip: true,
      registerServiceImg: null,
      showNewbieTaskReminder: false,
    };
  },
  methods: {
    // quitsavedialogClose(){
    //   this.isquitsavedialog=false
    //   localStorage.removeItem("temporarily");
    // }
    syncUserRoleState() {
      const rolesText = localStorage.roles;
      if (!rolesText) {
        this.userdisable = false;
        return;
      }

      try {
        const userroles = JSON.parse(rolesText);
        if (!Array.isArray(userroles) || userroles.length === 0) {
          this.userdisable = false;
          return;
        }

        userroles.sort(function (a, b) {
          return b.weight - a.weight;
        });
        this.userdisable = userroles[0].label == "initial_role";
      } catch (e) {
        this.userdisable = false;
      }
    },
    handleStorageChange(event) {
      if (
        event &&
        event.key &&
        !["t_k", "token", "roles", "time"].includes(event.key)
      ) {
        return;
      }

      this.syncUserRoleState();
    },
    handleTriggerClick() {
      this.showRobotBubble = false;
      // localStorage.setItem("aiRobotBubbleClosed", "1");
      this.toggleChatDialog();
    },
    closeRobotBubble() {
      this.showRobotBubble = false;
      // localStorage.setItem("aiRobotBubbleClosed", "1");
    },
    goToBindPhone() {
      this.showPhoneTip = false;
      this.$router.push("/personalinfo");
    },
    async loadRegisterWechatQr() {
      await this.waitForSiteConfig();
      this.registerServiceImg = this.getConfigValue(
        "wechatCustomerQrCodeForRegister",
      );
    },
  },
  mounted() {
    console.log(333);
    // if(localStorage.temporarily==true){
    //       this.isquitsavedialog=true
    //     }else{
    //       this.isquitsavedialog=false
    //     }
    // setTimeout(() => {
    //   this.isquitsavedialog=localStorage.temporarily
    // }, 500);
    // 从本地存储加载用户偏好的位置
    // const closedFlag = localStorage.getItem("aiRobotBubbleClosed");
    // this.showRobotBubble = closedFlag !== "1";
  },
  watch: {
    "$route.path"(toPath) {
      if (toPath == "/home") {
        this.ishome = true;
      } else {
        this.ishome = false;
        this.showWechatQr = false;
      }
    },
  },
  created() {
    if (this.$route.path == "/home") {
      this.ishome = true;
    } else {
      this.ishome = false;
    }
    this.loadRegisterWechatQr();
    window.addEventListener("resize", this.resize);
    window.addEventListener("storage", this.handleStorageChange);
    this.syncUserRoleState();
    // 返回值等于-1 说明数组Arr中不存在id为date的对象
    //     if( userroles.findIndex(item => item.label=== 'initial_role' )!==-1){
    // this.userdisable=true
    //     }
    // //console.log(this.$router)
    getUser().then((res) => {
      if (res && res.data) {
        this.isbindPhone = res.data.phoneBindingFlag;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.handleStorageChange);
  },
};
</script>
<style lang="less">
.homeview-style {
  .homeview-header {
    width: 100vw;
    background: transparent;
  }

  .content-style {
    overflow-y: scroll;
  }

  .homeview-header + .content-style {
    padding-top: 64px;
  }
  .content-style::-webkit-scrollbar {
    display: none;
  }
}
</style>
<style lang="less" scoped>
@import "@/assets/css/AIcanvas/other/AICanvasStyle.less";
@import "@/assets/css/toolpage/temporary_tip.less";

.homeview-style {
  position: relative;
}
.wechat-service-dock {
  position: fixed;
  right: 40px;
  bottom: 126px;
  z-index: 2500;
  transition: bottom 0.3s ease;
}

.wechat-service-dock.has-newbie-task-reminder {
  bottom: 216px;
}

.ai-chat-trigger.has-newbie-task-reminder {
  bottom: 150px;
}

.wechat-service-dock.position-left {
  right: auto;
  left: 20px;
}

.dock-btn {
  border: none;
  outline: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.wechat-btn {
  width: 50px;
  height: 50px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.03);
  background: rgba(15, 23, 42, 0.9);
  color: #3b82f6;
}

.wechat-btn:hover {
  border-color: rgba(59, 130, 246, 0.3);
  color: #ffffff;
  transform: scale(1.1);
  box-shadow: 0 0 18px rgba(59, 130, 246, 0.3);
}

.wechat-btn-icon {
  width: 22px;
  height: 22px;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-popover-card {
  position: absolute;
  right: 0;
  bottom: 66px;
  width: max-content;
  padding: 18px 20px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.98);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.8),
    0 0 20px rgba(59, 130, 246, 0.1);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: bottom right;
  z-index: 2600;
}

.wechat-service-dock.position-left .qr-popover-card {
  right: auto;
  left: 0;
  transform-origin: bottom left;
}

.qr-image-wrapper {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  padding: 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-image-wrapper img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.qr-text {
  margin: 14px 0 0;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: #94a3b8;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.temporary_tooltiptext {
  position: absolute;
  top: 130px;
  right: 10px;
}

@media (max-width: 639px) {
  .ai-chat-trigger.has-newbie-task-reminder {
    bottom: 134px;
  }

  .wechat-service-dock.has-newbie-task-reminder {
    bottom: 200px;
  }
}
</style>
